var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value.includes(_vm.name))?_c('span',[(_vm.value[0] === '-')?_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-arrow-down")]):_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-arrow-up")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }